import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { nonZeroCoordinateValidator } from 'src/app/utils/utils.common';
import { data } from 'jquery';
import * as moment from 'moment';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';

@Component({
  selector: 'app-clone-modal',
  templateUrl: './clone-modal.component.html',
  styleUrls: ['./clone-modal.component.css']
})
export class CloneModalComponent implements OnInit {
  @Input() cloneTrip;
  @Output() closeModal = new EventEmitter<any>()
  submitted = false;
  cloneForm!: FormGroup;
  tripId:any;


  constructor(
    private assignTripService : AssigTripsService,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.tripId = this.cloneTrip._id

    this.cloneForm = this.fb.group({
      preScheduleTime:['', Validators.required],
      scheduleTime: ['', Validators.required],
      preAppointmentTime:['', Validators.required],
      appointmentTime: ['', Validators.required],
      jobOriginAddress: ['', Validators.required],
      jobOriginLongitude: ['', [Validators.required, nonZeroCoordinateValidator()]],
      jobOriginLatitude: ['', [Validators.required, nonZeroCoordinateValidator()]],
      jobDestinationAddress: ['', Validators.required],
      jobDestinationLongitude: ['', [Validators.required, nonZeroCoordinateValidator()]],
      jobDestinationLatitude: ['', [Validators.required, nonZeroCoordinateValidator()]],
      milage: [''],
    });

    this.fillForm();
  }
  setOriginAddress(place){
    this.cloneForm.patchValue({
      jobOriginAddress: place.formatted_address,
      jobOriginLatitude: place.geometry.location.lat(),
      jobOriginLongitude: place.geometry.location.lng(),
    });
  }
  setDestinationAddress(place){
    this.cloneForm.patchValue({
      jobDestinationAddress: place.formatted_address,
      jobDestinationLatitude: place.geometry.location.lat(),
      jobDestinationLongitude: place.geometry.location.lng(),
    });
  }

  close() {
    this.closeModal.emit();
  }

  setDropOffTimeChange(event, index?) {
    this.cloneForm.patchValue({
            appointmentTime: moment(event).toISOString(),
          });
  }

  setPickTimeChange(event, index?) {
    this.cloneForm.patchValue({
            scheduleTime: moment(event).toISOString(),
          });
  }



  fillForm() {
    this.cloneForm.patchValue({
      ...this.cloneTrip,
      preScheduleTime: moment(this.cloneTrip.scheduleTime),
      preAppointmentTime: moment(this.cloneTrip.appointmentTime)

    })
  }


  onSave() {
    this.submitted = true;
    if (this.cloneForm.invalid) return;
    const payload = { ...this.cloneForm.value, assignThrough : 'panel' };

    this.assignTripService.createCloneTrip(this.cloneTrip._id, payload).subscribe((data)=>{
      if(data){
        this.cloneTrip.isJClone = true;
        this.close();

      }
    })
  }

get form(){
  return this.cloneForm.controls;
}

}
